import * as yup from 'yup'

const datePattern = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/
const timePattern = /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/

export const generalSettingsStepSchema = yup.object().shape({
  summary: yup.string().required('Campo obrigatório'),
  description: yup
    .string()
    .notRequired(),
  experts: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().required('Campo obrigatório'),
        email: yup
          .string()
          .email('E-mail inválido')
          .required('Campo obrigatório'),
      })
    )
    .notRequired(),
  researchers: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().required('Campo obrigatório'),
        email: yup
          .string()
          .email('E-mail inválido')
          .required('Campo obrigatório'),
      })
    )
    .notRequired(),
  analysts: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().required('Campo obrigatório'),
        email: yup
          .string()
          .email('E-mail inválido')
          .required('Campo obrigatório'),
      })
    )
    .notRequired(),
  contacts: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().required('Campo obrigatório'),
        email: yup
          .string()
          .email('E-mail inválido')
          .required('Campo obrigatório'),
      })
    )
    .notRequired(),
})

export const timeStepSchema = yup.object().shape({
  date: yup
    .string()
    .required('Campo obrigatório')
    .matches(datePattern, 'Data inválida'),
  startTime: yup
    .string()
    .required('Campo obrigatório')
    .matches(timePattern, 'Horário inválido'),
  endTime: yup
    .string()
    .required('Campo obrigatório')
    .matches(timePattern, 'Horário inválido')
    .test({
      name: 'compareWithStartAt',
      message: 'Horário de inválido',
      test (endTime) {
        if (!endTime) {
          return false
        }

        const isStartAtValid = timePattern.test(this.parent.startTime)
        const isEndAtValid = timePattern.test(endTime)

        if (!isStartAtValid && !isEndAtValid) {
          return false
        }

        const date = this.parent.date.split('/').reverse().join('-')

        const firstDateTimestamp = new Date(
          `${date} ${this.parent.startTime}`
        ).getTime()
        const secondDateTimestamp = new Date(
          `${date} ${this.parent.endTime}`
        ).getTime()

        return firstDateTimestamp < secondDateTimestamp
      },
    }),
})
